import {Dialog, Typography} from '@mui/material';
import {useEffect, useState} from 'react';
import AnimatedProgreesBar from '../aur-pizza-traker-progress/component/AnimatedProgressBar';
import SearchOutlinedIcon from '@mui/icons-material/SearchOutlined';
import AurButton from '../aur-button/AurButton';
import {t} from 'i18next';
import {ReactComponent as FileSvgIcon} from '../../../assests/svg/file.svg';
import AurSvgIcon from '../aur-svg-icon/AurSvgIcon';

interface AurEcaSearchLoaderProps {
  isOpen: boolean;
  keepMounted: boolean;
  onClose: (value?: string) => void;
  isExportDoc?: boolean;
  isExportForm?: boolean;
}

const AurEcaSearchLoader: React.FC<AurEcaSearchLoaderProps> = ({
  isOpen,
  onClose,
  isExportDoc,
  isExportForm,
  ...other
}) => {
  const [counter, setCounter] = useState<number>(0);
  const [heading, setHeading] = useState<string>('');
  const [subheading, setSubheading] = useState<string>('');

  useEffect(() => {
    if (counter >= 3) return;
    const interval = setInterval(() => setCounter((prev) => prev + 1), 20000);
    if (isExportDoc) {
      setHeading(
        t(`common.aurEcaSearchLoader.exportHeader${counter === 0 ? 1 : 2}`)
      );
      setSubheading(
        t(`common.aurEcaSearchLoader.exportSubHeader${counter === 0 ? 1 : 2}`)
      );
    } else if (isExportForm) {
      setHeading(t('eca.newExport.newExportLoaderheading'));
      setSubheading(t('eca.newExport.newExportLoaderDesc'));
    } else {
      setHeading(t(`common.aurEcaSearchLoader.heading${counter + 1}`));
      setSubheading(t(`common.aurEcaSearchLoader.subHeading${counter + 1}`));
    }

    return () => {
      clearInterval(interval);
    };
  }, [counter, isExportDoc]);

  let IconComponent: React.ReactNode;

  if (isExportDoc) {
    IconComponent = <FileSvgIcon />;
  } else if (isExportForm) {
    IconComponent = (
      <AurSvgIcon src="../assests/images/new_export_tags.svg" ariaHidden />
    );
  } else {
    IconComponent = <SearchOutlinedIcon className="search-color" />;
  }

  return (
    <div data-testid="eca-search-loader">
      <Dialog
        fullScreen={true}
        open={isOpen}
        PaperProps={{className: 'overlay'}}
        {...other}
      >
        <div className="eca-search-loader-main">
          <div className="pulse-icon-container">
            <div className="pulse-outer-container">
              <div className="pulse"></div>
              <div className="container">{IconComponent}</div>
            </div>
            <AnimatedProgreesBar status={'Processing'} width={156} />
            <div className="empty-space-container"></div>
          </div>
          <div className="title-container">
            {
              <Typography className="typo-text headline2_size head-text">
                {heading}
              </Typography>
            }
            {
              <Typography className="typo-text body2_size sub-head-text">
                {subheading}
              </Typography>
            }
          </div>
          <div className="title-container">
            <AurButton
              type="text"
              label={
                isExportDoc
                  ? t('common.aurEcaSearchLoader.cancelExportBtn')
                  : t('common.aurEcaSearchLoader.cancelBtn')
              }
              title={
                isExportDoc
                  ? t('common.aurEcaSearchLoader.cancelExportBtn')
                  : t('common.aurEcaSearchLoader.cancelBtn')
              }
              size="Medium"
              onClick={() => onClose('cancel')}
            />
          </div>
        </div>
      </Dialog>
    </div>
  );
};

export default AurEcaSearchLoader;
